module.exports = __webpack_public_path__ + "img/antibody.8ed986ac.png";